export const UPDATE_APP_MODE = "setting/UPDATE_APP_MODE";
export const RESET_SETTING = "setting/RESET";
export const UPDATE_REDUX_RESTORE_STATE = "setting/UPDATE_REDUX_RESTORE_STATE";
export const UPDATE_THEME = "setting/UPDATE_THEME";
export const UPDATE_LANGUAGE = "setting/UPDATE_LANGUAGE";
